import { apiGet, apiPost, apiPut } from '@/services/api/apiClient';

export interface MaterialUsed {
  materialId: string;
  quantityCount: number;
  quantityKg: number;
}

export interface WorkProcessItem {
  id: string;
  poId: string;
  materialsUsed?: MaterialUsed[];
  // companyId: string;
  startDateTime?: string;
  endDateTime?: string;
  createdBy?: {
    _id:string;
    name:string;
    empId:string;
    email:string;
    mobile:string;
  };
  updatedBy?: {
    _id:string;
    name:string;
    empId:string;
    email:string;
    mobile:string;
  };
   companyId?: {
    _id:string;
    name:string;
    email:string;
    mobile:string;
  };
  status: 'pending' | 'progress' | 'completed';
  isActive: boolean;
  isDeleted: boolean;
  remarks?: string;
  createdAt: string;
  updatedAt: string;
  // Additional fields for accountsDispatch
  dispatchedDateTime?: string;
  vehicleNumber?: string;
  invoiceNumber?: string;
  invoiceDate?: string;
}

export interface WorkProcessSummary {
  punchingLaser: WorkProcessItem[];
  bendingMachine: WorkProcessItem[];
  weldingGrinding: WorkProcessItem[];
  powderCoating: WorkProcessItem[];
  assembly: WorkProcessItem[];
  accountsDispatch: WorkProcessItem | null;
}

export interface WorkProcessSummaryResponse {
  success: boolean;
  message: string;
  data: WorkProcessSummary;
}

export interface WorkProcessFormData {
  poId: string;
  materialsUsed?: MaterialUsed[];
  companyId: string;
  userId?: string;
  status?: 'pending' | 'progress' | 'completed';
  remarks?: string;
  // Additional fields for level 6 (accountsDispatch)
  dispatchedDateTime?: string;
  vehicleNumber?: string;
  invoiceNumber?: string;
  invoiceDate?: string;
}

export interface WorkProcessResponse {
  success: boolean;
  message: string;
  data: WorkProcessItem;
}

class WorkProcessService {
  private baseUrl = '/workprocess';

  async getWorkProcessSummary(poId: string): Promise<WorkProcessSummaryResponse> {
    return apiGet<WorkProcessSummaryResponse>(`${this.baseUrl}/summary/po/${poId}`);
  }

  async createWorkProcess(level: number, data: WorkProcessFormData): Promise<WorkProcessResponse> {
    return apiPost<WorkProcessResponse>(`${this.baseUrl}/level/${level}`, data);
  }

  async updateWorkProcess(level: number, id: string, data: WorkProcessFormData): Promise<WorkProcessResponse> {
    return apiPut<WorkProcessResponse>(`${this.baseUrl}/level/${level}/${id}`, data);
  }
}

export const workProcessService = new WorkProcessService();